import React from 'react'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import MasterCardIcon from '../../../assets/icons/JSX/MasterCardIcon'
import OtherCard from '../../../assets/icons/JSX/OtherCard'
import VisaCardIcon from '../../../assets/icons/JSX/VisaCardIcon'
import Responsive from '../../../assets/config/Responsive'
import Checkbox from '../buttons/Checkbox'
import { useTranslation } from 'react-i18next'
import InfoMessage from '../InfoMessage'
//
//
const PaymentCard: React.FC<{
  selected: boolean
  cardName: string
  saleCount?: number
  cardType?: 'master' | 'visa' | 'other' | string
  subscriptionCheckbox?: boolean
  subscriptionValue?: boolean
  onChecboxClick?: () => void
  onClick?: () => void
}> = ({
  selected = false,
  cardName = 'Card Name',
  saleCount,
  cardType,
  subscriptionCheckbox,
  subscriptionValue,
  onClick,
  onChecboxClick,
}) => {
  //
  const { t } = useTranslation()
  //
  return (
    <Card $checked={selected} onClick={onClick}>
      <CardNameDiv>
        <PaymentIcons>
          {cardType && cardType === 'master' && <MasterCardIcon />}
          {cardType && cardType === 'visa' && <VisaCardIcon />}
          {cardType && cardType === 'other' && <OtherCard />}
        </PaymentIcons>
        <CardNameText>{cardName}</CardNameText>
        {saleCount ? <Sale>-{saleCount}%</Sale> : null}
        <CheckedStyle $checked={selected} />
      </CardNameDiv>
      {selected && subscriptionCheckbox && (
        <CheckboxDiv>
          <Checkbox
            id="remember-card-checkbox"
            label={`${t('rememberMyCardCheck')}`}
            checked={subscriptionValue}
            defaultChecked={subscriptionValue}
            onClick={onChecboxClick}
          />

          <InfoMessage
            background="gray"
            variant="info"
            title={`${t('rememberMyCardTitle')}`}
            text={`${t('remeberMyCardInfo')}`}
          />
        </CheckboxDiv>
      )}
    </Card>
  )
}
//

const CheckedStyle = styled.div<{ $checked: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  right: 16px;
  border: ${({ $checked }) => ($checked ? 'unset' : `solid 1px ${Colors.nevadaGrey}`)};
  box-shadow: ${({ $checked }) => ($checked ? `inset 0px 0px 0px 11px ${Colors.primaryRed}` : 'unset')};

  ${Responsive.mobile} {
    width: 26px;
    height: 26px;
    box-shadow: ${({ $checked }) => ($checked ? `inset 0px 0px 0px 9px ${Colors.primaryRed}` : 'unset')};
  }
`
const Sale = styled.div`
  background-color: ${Colors.lightRed};
  padding: 5px 9px;
  display: grid;
  place-items: center;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: ${Colors.primaryRed};
  border-radius: 2px;

  ${Responsive.mobile} {
    font-size: 14px;
    padding: 5px 6px;
  }
`
const CardNameText = styled.div`
  margin-right: 22px;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${Colors.primaryBlack};
  text-transform: capitalize;

  ${Responsive.mobile} {
    margin-right: 17px;
    font-size: 17px;
  }
`
const CardNameDiv = styled.div`
  width: 100%;
  max-width: 464px;
  display: flex;
  align-items: center;
`
const CheckboxDiv = styled.div`
  width: 100%;
  max-width: 464px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const PaymentIcons = styled.div`
  margin-right: 30px;

  svg {
    max-height: 62px;
  }

  ${Responsive.mobile} {
    margin-right: 14px;
  }
`
const Card = styled.div<{ $checked: boolean }>`
  width: 100%;
  max-width: 464px;
  background-color: ${Colors.white};
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 30px 48px;
  position: relative;
  outline: ${({ $checked }) => ($checked ? `1px solid ${Colors.primaryBlack}` : 'unset')};
  transition: all 200ms ease-out;

  &:hover {
    outline: 1px solid ${Colors.primaryBlack};
    cursor: pointer;
    transition: all 200ms ease-out;
  }

  ${Responsive.mobile} {
    padding: 30px;
  }
`
//
export default PaymentCard
